import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import { BarragemData, UserFuncao } from '../../context';
import { Delete } from '@mui/icons-material';
import { ErrorOnDialog, LoadingModal } from '../modals';
import { RequestError, useApi } from '../../services';

export interface FuncionarioFuncaoProps extends UserFuncao {
  onRemove?: () => void;
  onChange?: (funcao: UserFuncao) => void;
}

export const FuncionarioFuncao: React.FC<FuncionarioFuncaoProps> = ({
  id,
  funcionario,
  barragem,
  setor,
  funcao,
  onRemove,
  onChange
}) => {
  const api = useApi();

  const starting = useRef(true);
  const timer = useRef<NodeJS.Timeout>();

  const [_setor, setSetor] = useState(setor || '');
  const [_funcao, setFuncao] = useState(funcao || '');
  const [_barragem, setBarragem] = useState<BarragemData>();
  const [error, setError] = useState<RequestError>();

  useEffect(() => {
    api.barragem.getBarragemById(barragem).then(value => {
      if ("error" in value) {
        setError(value);
        return;
      }
      setBarragem(value);
    });
  }, [barragem]);

  useEffect(() => {
    if (starting.current) {
      starting.current = false;
      return;
    }

    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      onChange?.({
        id,
        funcionario,
        barragem,
        setor: _setor ? _setor : undefined,
        funcao: _funcao ? _funcao : undefined,
      });
    }, 500);

  }, [_setor, _funcao]);

  if (!_barragem) return <LoadingModal open={true} message="Carregando Barragem..." />;

  return (
    <>

      {error && <ErrorOnDialog
        open={Boolean(error)}
        error={error.error}
        message={error.message}
        onClose={() => setError(undefined)}
      />}

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Barragem */}
        <Box>
          <Typography variant="body2" color="text.secondary">
            Barragem
          </Typography>
          <Typography variant="body1">{_barragem.nome}</Typography>
        </Box>

        <Box sx={{ gap: 2, display: "flex", flexDirection: "row" }}>
          {/* Setor */}
          <TextField
            fullWidth
            label="Setor"
            size="small"
            value={_setor}
            onChange={(e) => setSetor(e.target.value)}
          />

          {/* Função */}
          <TextField
            fullWidth
            label="Função"
            size="small"
            value={_funcao}
            onChange={(e) => setFuncao(e.target.value)}
          />

          {/* Remover função */}
          {onRemove && <IconButton onClick={onRemove}>
            <Delete />
          </IconButton>}

        </Box>
      </Box>
    </>
  );
};
